import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import { googleClickDropdownEvent } from '../../../../../utils/analytics';
import Icon from '../../../../@shared/icon';
import { TColumnDropdown } from '../../../types/index.types';

const DropdownMenu: FC<TColumnDropdown> = (props) => {
  const { colHeadings, colOrdInIndex, columnIndex, setColOrdInIndex, setDropdownAtColumnIndex, fixedDropdown } = props;

  return (
    <div
      className={`
          model-detail-specification-table__col-dropdown
          ${
            fixedDropdown
              ? 'model-detail-specification-table__col-dropdown--fixed'
              : 'model-detail-specification-table__col-dropdown--absolute'
          }
      `}
    >
      <div className="model-detail-specification-table__col-dropdown-item-wrapper model-detail-specification-table__col-dropdown-item-wrapper--with-title-and-icon ">
        <div className="model-detail-specification-table__col-dropdown-item model-detail-specification-table__col-dropdown-item--with-title-and-icon">
          {colHeadings?.[colOrdInIndex[columnIndex]]}
        </div>
        <div onClick={(): void => setDropdownAtColumnIndex(null)}>
          <Icon iconName="action-close" size={iconSize.dsk} extraClassName="table-dropdown-close-icon" />
        </div>
      </div>
      {colHeadings?.map((eachColName, dropdownInd) => (
        <div
          key={eachColName}
          onClick={() => {
            googleClickDropdownEvent('Select', eachColName);
            setColOrdInIndex((data) => {
              data[columnIndex] = dropdownInd;
              setDropdownAtColumnIndex(null);
              return [...data];
            });
          }}
          className="model-detail-specification-table__col-dropdown-item-wrapper"
        >
          <div className="model-detail-specification-table__col-dropdown-item">{eachColName}</div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(DropdownMenu);
